/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getPassengersList: (params) => {
    return axios.get(API_ENDPOINTS.GET_DemoAccount_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getDemoaccountDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_DemoAccount_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  addDemoaccount: (data) => {
    return axios.post(API_ENDPOINTS.ADD_DEMOACCOUNT, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json", },
    });
  },
  updateDemoAccount: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_DeomAccount_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data", },
    });
  },
  deleteDemoaccount: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_DemoAccount_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  deletedriver: (data) => {
  return axios.delete(API_ENDPOINTS.DELETE_DRIVER, {
    headers: { isAuthRequired: true, "Content-Type": "application/json" },
    data
  });
  },
  getPassengerrequesthistory: (params) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY + "/" + params.passenger_id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params
    });
  },
  getPassengerrequesthistorybyid: (id) => {
    return axios.get(API_ENDPOINTS.GET_PASSENGER_REQUEST_HISTORY_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
  getdemoaccounts: (id) => {
    return axios.get(API_ENDPOINTS.GET_DEMOACCOUNT_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
  deletePassengerrequesthistorybyid: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_PASSENGER_REQUEST_BYID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" }
    });
  },
};
